;(function (window, APP, Backbone, Marionette, $, _) {
	Backbone.Form.editors.DateCustom = Backbone.Form.editors.Base.extend({
	previousValue: '',
	ui: {
		day : '.day-input-picker',
		month: '.month-input-picker',
		//year: ''
	},
	events: {
		'hide': "hasChanged",
		'changeDate': "hasChanged",
		'change .day-input-picker,.month-input-picker': 'convertNumber',
		'click .add-on': "showHideDatePicker"
	},
	day: '',
	month: '',
	year: '',
	hasChanged: function(currentValue) {
		if (currentValue !== this.previousValue){
			this.previousValue = currentValue;
			this.trigger('change', this);
		}
		$('#datepicker').show();
	},
	initialize: function(options) {
		Backbone.Form.editors.Base.prototype.initialize.call(this, options);
		this.template = options.template || this.constructor.template;
		if(this.getValue()){
			var date = moment(this.getValue());
			this.day = date.format("DD");
			this.month = date.format("MM");
			this.year = date.format("YYYY");
		}
	},
	render: function(){
		var $el = $($.trim(this.template({
			dateFormat: this.schema.options[0]["dateFormat"],
			value: this.schema.options[0]["defaultValue"],
			day : this.day,
			month: this.month,
			year: this.year
		})));
		this.setElement($el);
		this.$el.find('#datepicker').datepicker();
		this.$el.find('#datepicker').hide();
		return this;
	},
	convertNumber: function(event){
		var inputVal = $(event.target).val();
		if(inputVal.length === 1){
			$(event.target).val('0' + inputVal)
		}
	},
	showHideDatePicker: function(){
		this.$el.find('#datepicker').toggle()
	}

}, {
	// STATICS
	template: _.template('<div class="input-append">\
  <input type="text" id="start_date"  name="start_date" style="display:none" data-date-format="<%= dateFormat %>" class="datepicker input input-medium" readonly="readonly" value="<%= value %>">\
  <input class="day-input-picker" type="number" name="date_picker_day" value="<%= day %>" placeholder="DD" min="1" max="31">\
  <input class="month-input-picker" type="number" name="date_picker_month" value="<%= month %>" placeholder="MM" min="1" max="12">\
  <input type="number" name="date_picker_year" value="<%= year %>" placeholder="YYYY">\
  <div id="datepicker" data-date="<%= value %>"></div>\
  <span class="add-on"><i class="fa fa-calendar"></i></span></div>', null, Backbone.Form.templateSettings)
});
}(window, APP, Backbone, Marionette, $, _));
